import React from 'react';
import NotesButton from './NotesButton';

/**
 * Notes internes d'un extra / credit (colonne Actions du tableau des extras) :
 * le composant generique NotesButton, branche sur extra_notes. Meme affichage
 * qu'avant (sous-titre « n° · titre »).
 */
const ExtraNotesButton = ({ extra, projectId, number, summary, onChanged }) => (
  <NotesButton
    entityType="extra"
    entityId={extra?.id}
    projectId={projectId}
    subtitle={`${number || '—'} · ${extra?.title || '—'}`}
    summary={summary}
    onChanged={onChanged}
  />
);

export default ExtraNotesButton;
